import { Component } from '@angular/core';

@Component({
  selector: 'app-download-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './download-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class DownloadIconComponent {}
